export const SET_THEME = "SET_THEME";
export const SET_CONNECTION_REFERENCE = "SET_CONNECTION_REFERENCE";
export const SET_HEADER_VISIBILITY = "SET_HEADER_VISIBILITY";
export const SET_MAIN_MENU_VISIBILITY = "SET_MAIN_MENU_VISIBILITY";
export const SET_FOOTER_VISIBILITY = "SET_FOOTER_VISIBILITY";
export const REFRESH_STATUS_BAR = "REFRESH_STATUS_BAR";